module.exports = __webpack_public_path__ + "img/banner1.a6c33cc1.png";